import { BaseModel } from '../base-model';

export interface IAppointmentPerSon {
  AddressTitle?: string;
  CompanyName?: string;
  FirstName?: string;
  Id?: number;
  Name?: string;
  Reference?: string
}
export class AppointmentPerSon extends BaseModel<IAppointmentPerSon> implements IAppointmentPerSon {
  /**
   *
   */
  constructor(options?: IAppointmentPerSon) {
    super(options);
  }
}
